import React from "react";
import "./bannerAds.css";
import mobileMockup from "../../assets/images/mobileMockup.png";
import qrCode from "../../assets/images/qrCode.png"; 

const BannerAds = () => {
  return (
    <div className="container bannerAds-section text-white p-md-5 px-4 py-5 position-relative">
      <div className="row align-items-center justify-content-center">
        <div className="col-md-3 text-center">
          <img src={mobileMockup} alt="Mobile Mockup" className="img-fluid mobile-mockup" />
        </div>
        <div className="col-md-8 text-center">
          <h2 className="fw-bold">Download Tixbook App</h2>
          <p>Scan QR to download</p>
          <img src={qrCode} alt="QR Code" className="img-fluid qr-code  mt-2" />
        </div>
      </div>
    </div>
  );
};

export default BannerAds;
